export enum NODE_TYPES {
  ROOT = "ROOT",
  SECTION = "SECTION",
  BLOCK = "BLOCK",
}
